import { useSnackbar } from '../contexts/SnackbarContext';

// Global snackbar functions that can be used in API responses or other non-component code
let globalShowSnackbar: ((message: string, variant: 'success' | 'error' | 'info', duration?: number) => void) | null = null;

export const setGlobalSnackbar = (showSnackbar: (message: string, variant: 'success' | 'error' | 'info', duration?: number) => void) => {
  globalShowSnackbar = showSnackbar;
};

export const successSnackbar = (message: string, duration?: number) => {
  if (globalShowSnackbar) {
    globalShowSnackbar(message, 'success', duration);
  } else {
    console.warn('Snackbar not initialized. Make sure SnackbarProvider is rendered.');
    console.log(`[SUCCESS] ${message}`);
    alert(message); // Fallback to browser alert
  }
};

export const errorSnackbar = (message: string, duration?: number) => {
  if (globalShowSnackbar) {
    globalShowSnackbar(message, 'error', duration);
  } else {
    console.warn('Snackbar not initialized. Make sure SnackbarProvider is rendered.');
    console.error(`[ERROR] ${message}`);
    alert(message); // Fallback to browser alert
  }
};

export const infoSnackbar = (message: string, duration?: number) => {
  if (globalShowSnackbar) {
    globalShowSnackbar(message, 'info', duration);
  } else {
    console.warn('Snackbar not initialized. Make sure SnackbarProvider is rendered.');
    console.info(`[INFO] ${message}`);
    alert(message); // Fallback to browser alert
  }
};